/* global axios */
import ApiClient from './ApiClient';

class CouriersAPI extends ApiClient {
  constructor() {
    super('courier_info', { accountScoped: true });
  }

  get(contactId) {
    return axios.get(`${this.baseUrl()}/contacts/${contactId}/courier_info`);
  }
}

export default new CouriersAPI();
